import type { WorkspaceType } from 'state/workspaces/model';

import type { DataById } from './formData.model';
import type { PatchedFieldsComputed } from './patchedFields/patchedFields.actions';

export type FormDataAction =
  | FormEnrichedDataReceived
  | FormInputDataChanged
  | FormInputDataReverted
  | FormEnrichmentRequested
  | PatchedFieldsComputed;

export function formEnrichedDataReceived(tabId: string, formId: string, data: DataById, workspace: WorkspaceType) {
  return {
    type: 'FORM_ENRICHED_DATA_RECEIVED' as const,
    tabId,
    formId,
    data,
    workspace,
  };
}
export type FormEnrichedDataReceived = ReturnType<typeof formEnrichedDataReceived>;

export function formInputDataChanged(
  tabId: string,
  formId: string,
  key: string,
  value: Readonly<unknown>,
  workspace: WorkspaceType,
) {
  return {
    type: 'FORM_INPUT_DATA_CHANGED' as const,
    tabId,
    formId,
    key,
    value,
    workspace,
  };
}
export type FormInputDataChanged = ReturnType<typeof formInputDataChanged>;

export function formInputDataReverted(tabId: string, formId: string) {
  return {
    type: 'FORM_INPUT_DATA_REVERTED' as const,
    tabId,
    formId,
  };
}
export type FormInputDataReverted = ReturnType<typeof formInputDataReverted>;

export function formEnrichmentRequested(tabId: string, formId: string, patch: DataById, workspace: WorkspaceType) {
  return {
    type: 'FORM_ENRICHMENT_REQUESTED' as const,
    tabId,
    formId,
    patch,
    workspace,
  };
}
export type FormEnrichmentRequested = ReturnType<typeof formEnrichmentRequested>;
